import React, { useRef, useEffect } from "react";
// import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
// import ButtonPage from "../../components/ui/ButtonPage.js";
// import Heading from "../../components/ui/Heading.js";
import Button from "../../components/ui/Button.js";
// import Faq from "../../components/ui/Faq.js";
// import Testimonial2 from "../../components/ui/Testimonial2.js";
// import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";

const Sectors = () => {

  const formRef = useRef(null);
  // const history = useHistory();
  // const [activeTab, setActiveTab] = useState("Corporate Law");

  // const handleClick = (field) => {
  //   history.push(field ? `/${field}` : "/");
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };


  return (
    <>
      <div className="overflow-hidden">

        <section className="bg-cover bg-no-repeat bg-right w-full h-auto bgpagecolor" style={{ backgroundImage: `url('/assets/home/practice-areas-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0 md:py-20 w-full 2xl:w-9/12 xl:w-11/12 h-full">
              <div className="flex flex-col justify-center space-y-8 mx-auto my-auto pt-10 md:pt-0 md:pb-12 w-full h-full md:text-left text-center">
                <h1 className="font-bold text-5xl xl:text-6xl text-white">Legal Expertise That Understands Your Industry</h1>
                <div className="font-medium text-base md:text-lg text-white">
                  <p className="pb-2">We bring deep, sector-specific legal insight to help clients navigate industry complexities, manage risk, and drive growth with confidence.</p>
                </div>
                <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-80 w-full">
                  <Button text="Schedule a Free Consultation" onClick={handleScrollToForm} />
                </div>
              </div>

              <div className="flex justify-center items-center w-full">
                <img data-aos="fade-left" src="/assets/home/sectors.webp" alt="practice-areas" className="z-0" />
              </div>
            </div>
          </div>
        </section>


        <section className="bg-[#E7EDF4] md:py-16 py-8">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <h1 className="font-bold text-5xl xl:text-6xl textblack">Sectors We Serve</h1>
            <p className="textblack mt-4 mb-10">
              Industry-specific legal expertise that delivers.
            </p>

            {JsonData.sectors.map((data, index) => (
              <div className="bg-white rounded-lg shadow p-6 flex flex-col md:flex-row gap-6 mb-4 group hover:bg-[#003366]">
                <div className="md:w-1/3">
                  <img src={data.image} alt={data.title} className="rounded-md w-full h-full object-cover" />
                </div>
                <div className="md:w-2/3 text-left p-4">
                  <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 group-hover:text-white">{data.title}</h1>
                  <p className="text-gray-700 mb-4 group-hover:text-white">{data.description}</p>
                  <ul className="list-disc space-y-2 text-gray-700 pl-8 group-hover:text-white">
                    {data.points.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* <section className="bg-[#fdf7ed] py-16">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <h2 className="text-4xl font-semibold text-gray-900 mb-2">Meet Our Expert Expertise</h2>
            <p className="text-gray-600 mb-10">
              Trusted by individuals and businesses for sound legal advice, strategic.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-10">
              {JsonData.Expertise.map((lawyer, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm">
                  <div className="bg-[#f6e5c6] flex items-center justify-center">
                    <img src={lawyer.image} alt={lawyer.name} className="h-full object-contain" />
                  </div>
                  <div className="p-4">
                    <h4 className="text-lg font-semibold textblack py-4">{lawyer.name}</h4>
                    <p className="text-sm textblack mb-4 line-clamp-2 h-12">{lawyer.title}</p>
                    <div className="flex justify-center items-center gap-4 w-full">
                      <Button text="View Profile" onClick={handleScrollToForm} />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="bg-[#deb059] hover:bg-[#cfa248] text-white px-6 py-3 rounded-md text-sm font-medium inline-flex items-center gap-2 transition">
              View All <span>→</span>
            </button>
          </div>
        </section> */}

        {/* <Faq /> */}

        {/* <section className="py-8 bg-[#212121]">
          <div className="flex flex-col items-center justify-between w-full gap-10 px-4 py-10 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
            <div className="flex flex-col justify-center md:text-left text-center">
              <h1 className="text-3xl font-medium leading-tight title-font text-white">Explore Legal Support That Works for You</h1>
              <p className="text-3xl font-medium leading-tight title-font text-white"></p>
            </div>
            <div className="flex flex-col items-center justify-center flex-shrink-0 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 lg:ml-4 lg:justify-end">
              <Button text="Book a Demo" onClick={handleScrollToForm} />
            </div>
          </div>
        </section> */}

        {/* <Testimonial2 /> */}

        {/* <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </>
  );
};


export default Sectors;
